import { render, staticRenderFns } from "./UnverifiedReasons.vue?vue&type=template&id=84b697cc&scoped=true"
import script from "./UnverifiedReasons.vue?vue&type=script&lang=js"
export * from "./UnverifiedReasons.vue?vue&type=script&lang=js"
import style0 from "./UnverifiedReasons.vue?vue&type=style&index=0&id=84b697cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b697cc",
  null
  
)

export default component.exports